/**
 * Gemeinsame Konstanten der /mcp-Seite. Die Server-URL ist zugleich das
 * Markenelement der Seite (Copy-Feld im Hero und im Verbinden-Modul).
 */
export const MCP_URL = "https://mcp.webmetic.de/mcp";

/** Vorbefüllter claude.ai-Deeplink aus data-hub/mcp_server/docs/SETUP.md. */
export const CLAUDE_CONNECT_URL =
  "https://claude.ai/customize/connectors?modal=add-custom-connector&connectorName=Webmetic&connectorUrl=https%3A%2F%2Fmcp.webmetic.de%2Fmcp";

/** Öffnet im Dashboard direkt den API-Schlüssel-Drawer (Menü-Deeplink). */
export const DASHBOARD_API_KEY_URL = "https://app.webmetic.de/?menu=api_details";

/** Öffentliches Repo mit Doku, Beispielen und den fertigen Skills. */
export const GITHUB_URL = "https://github.com/webmetic-gmbh/webmetic-mcp";
